export interface TemplateConfiguration {
  template?: string;
  templateUrl?: string;
  component?: string;
}

/**
 * Service for fetching template strings.
 */
export interface TemplateService {
  /**
   * Returns a template given a configuration file that has a template, templateUrl, or component property.
   *
   * @param viewConfiguration A view configuration object containing some property to fetch templates.
   * @returns A promise wrapping a template string.
   */
  getTemplate(templateConfiguration: TemplateConfiguration): ng.IPromise<string>;
}

export class TemplateServiceImplementation implements TemplateService {
  // @ngInject
  constructor(private $q: ng.IQService, private $templateRequest: ng.ITemplateRequestService) {}

  public getTemplate(templateConfiguration: TemplateConfiguration): ng.IPromise<string> {
    if (templateConfiguration.template !== undefined) {
      return this.$q.resolve(templateConfiguration.template);
    } else if (templateConfiguration.templateUrl !== undefined) {
      return this.$q.resolve(this.$templateRequest(templateConfiguration.templateUrl));
    } else if (templateConfiguration.component !== undefined) {
      return this.$q.resolve(this.getComponentTemplate(templateConfiguration.component));
    } else {
      return this.$q.reject(`Template view configuration ${templateConfiguration}
                 must include template, templateUrl, or component field.`);
    }
  }

  // Use angular's snake case function to replicate snake case functionality
  private snakeCaseRegexp = /[A-Z]/g;
  public snakeCase(name: string, separator?: string) {
    separator = separator || "_";
    return name.replace(this.snakeCaseRegexp, function (letter, pos) {
      return (pos ? separator : "") + letter.toLowerCase();
    });
  }

  public getComponentTemplate(componentName: string, bindings?: any) {
    let attrs = bindings || {};
    let kebobName = this.snakeCase(componentName, "-");
    let attributeString = Object.keys(attrs)
      .map((attributeKey) => {
        return this.snakeCase(attributeKey, "-") + '="' + attrs[attributeKey] + '"';
      })
      .join(" ");

    return `<${kebobName} ${attributeString}></${kebobName}>`;
  }
}
